// 表单提交操作
document.addEventListener('submit', async function(event) {
    console.log(11111111111)
    console.log(event.target)

    // 如果是添加到购物车
    if (0 && event.target && event.target?.attributes?.action?.value === '/cart/add') {
        event.preventDefault(); // 阻止默认的表单提交行为
        const config = {
            // method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
        }
        const productId = event.target.id.value
        fetch(`http://sitang.local.com/shopify/products/${productId}`, config).then(res => {
            return res.json()
        }).then(res => {
            console.log(res)
            // 判断是否自定义价格

        })
    }

    // 购物车提交下单
    if(0){
        event.preventDefault(); // 阻止默认的表单提交行为
        try {
            await fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    console.log(cart) // 购物车对象
                    let hasCustomProduct = false
                    for (const item of cart.items) {
                        if(item?.properties?.is_custom && item.properties.is_custom == '1'){
                            hasCustomProduct = true
                            break;
                        }
                    }
                    if(hasCustomProduct){
                        const config = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
                            body: JSON.stringify(cart)
                        }
                        fetch('http://sitang.local.com/shopify/draftOrders', config).then(res => {
                            return res.json()
                        }).then(res => {
                            location.href = res.data.invoice_url
                        })
                    } else {
                        // event.target.submit();
                    }
                })
                .catch(error => console.error('Error fetching cart:', error));

        } catch (error) {
            console.error('Error during form validation:', error);
            alert('An error occurred. Please try again.');
        }
    }

});